import type { VerenaProof, VerenaStatus } from './config';

const STORAGE_KEY = 'verena_proof';

export function storeProof(proof: VerenaProof): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(proof));
  } catch {
    // sessionStorage might not be available
  }
}

export function getProof(): VerenaProof | null {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY);
    if (!data) return null;
    const proof: VerenaProof = JSON.parse(data);
    // Check expiry
    if (proof.expiresAt && Date.now() / 1000 > proof.expiresAt) {
      clearProof();
      return null;
    }
    return proof;
  } catch {
    return null;
  }
}

export function clearProof(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function getStatus(): VerenaStatus {
  const proof = getProof();
  if (proof) {
    return { verified: true, expiresAt: proof.expiresAt };
  }
  return { verified: false };
}
